<h4>Token: {{token?.name}}</h4>
<h4>Token: {{tokenStr}}</h4>
<h6>Owner: {{token?.owner}}</h6>
<user-payment-sum [userBillingStatus]="userBillingStatus" [tokenType]="token?.type" [loadingFlag]="loadingFlag"
    (loadingFlagChange)="loadingFlag = $event"></user-payment-sum>
<hr />
<div class="token-details">
    <div class="countCurrentMonth">
        Count Current Month:
        {{countCurrentMonth}}
    </div>
    <div class="totalCount">
        Total Count:
        {{totalCount}}
    </div>
    <div class="totalCount" ng-if="token">
        Token Type:
        {{token?.type}}
    </div>
</div>
<div class="dateInput">
    <div class="dateInput">
        <label>Date: </label>
        <input type="text" [(ngModel)]="dateIsoStr" size="50" />
    </div>
    <div class="pathInput">
        <label>Path: </label>
        <input type="text" [(ngModel)]="path" size="50" />
    </div>
    <button (click)="search()">Search</button>
</div>
<div class="searchCount">
    Search Count
    {{searchCount}}
</div>

<div class="items">

    <table mat-table [dataSource]="items">
        <ng-container matColumnDef="path">
            <th mat-header-cell *matHeaderCellDef> Path </th>
            <td mat-cell *matCellDef="let item">
                <div>{{item.path}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="datetime">
            <th mat-header-cell *matHeaderCellDef> datetime </th>
            <td mat-cell *matCellDef="let item">
                <div>{{item.datetime}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="fileUid">
            <th mat-header-cell *matHeaderCellDef> fileUid </th>
            <td mat-cell *matCellDef="let item" class="scanLine">
                <div [ngClass]="{'clicked' : item.openFlag}" (click)="openItem(item)">{{item.fileUid}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="openDev">
            <th mat-header-cell *matHeaderCellDef> openDev </th>
            <td mat-cell *matCellDef="let item" class="scanLine">
                <div   (click)="openItemDev(item)">open dev</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef> download </th>
            <td mat-cell *matCellDef="let item" class="scanLine">
                <div   (click)="download(item)">download</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="html">
            <th mat-header-cell *matHeaderCellDef> html </th>
            <td mat-cell *matCellDef="let item" class="scanLine">
                <div   (click)="html(item)">html</div>
            </td>
        </ng-container>





        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>

    </table>
</div>

<div id="loader" *ngIf="loadingFlag"></div>